import { useQuery } from '@tanstack/react-query';
import { createLoyaltyQuery } from '~/services/loyalty/lib';
import { QueryKeys } from '~/services/loyalty/constants';
import { useLoyaltyContext } from '..';
import type {
    LoyaltyApiError,
    MemberAccountInformationResponse,
} from '~/lib/data-contract/loyalty';
import type { AllowedOptions } from '../allowedQueryOptions';

export const useMemberAccountInformation = <TData = MemberAccountInformationResponse>(
    options?: AllowedOptions<MemberAccountInformationResponse, TData>,
) => {
    const { businessCentralId, translate, trackError } = useLoyaltyContext();

    return useQuery<MemberAccountInformationResponse, LoyaltyApiError, TData>({
        queryKey: [QueryKeys.MEMBER_ACCOUNT_INFORMATION],
        queryFn: createLoyaltyQuery('GetMemberAccountInformation', translate, trackError, {
            memberId: businessCentralId,
        }),
        enabled: false,
        refetchOnWindowFocus: false,
        retry: false,
        gcTime: 1000 * 30,
        ...options,
    });
};
